// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
import selectedCourseRouter from './selectedCourse';
var courseRouter = {
  path: '/course',
  component: Layout,
  redirect: '/course/list',
  name: 'Course',
  alwaysShow: true,
  meta: {
    title: '课程',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/course/index');
    },
    name: 'course',
    meta: {
      title: '线下课程'
    }
  }, {
    path: 'category',
    component: function component() {
      return import('@/views/selectedCourse/CourseTaxonomy');
    },
    name: 'CourseCategory',
    meta: {
      title: '课程分类'
    }
  }, selectedCourseRouter]
};
export default courseRouter;